var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step"},[_c('div',{staticClass:"order",style:(_vm.configStyles.primary.background)},[_vm._v(" "+_vm._s(_vm.order)+" ")]),_c('div',{staticClass:"text"},[_c('h4',[_vm._v(_vm._s(_vm.step.title))]),_c('small',[_vm._v(_vm._s(_vm.step.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }